import adminBar from './modules/adminBar/adminBar';

adminBar();
